import { ModifierOption } from "../types";
import { useCreateModifierGroupMutation, useTypedSelector } from "../store";
import ModifierGroupForm from "../forms/ModifierGroup.form";
import { modifierGroupSchema } from "../configs";
import { showToast, ToastType } from "../utils/toast.utils";
import { useNavigate } from "react-router-dom";

const CreateModifierGroupWrapper = () => {
  const restaurant = useTypedSelector((state) => state.session.restaurant);

  if (!restaurant)
    return (
      <div className="w-full flex justify-center mt-4 text-xl font-semibold">
        Veuillez sélectionner un restaurant
      </div>
    );

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <CreateModifierGroup restaurantId={restaurant._id} />
    </div>
  );
};

interface CreateModifierGroupProps {
  restaurantId: string;
}

const CreateModifierGroup: React.FC<CreateModifierGroupProps> = ({
  restaurantId,
}) => {
  const [CreateModifierGroup, { isLoading }] = useCreateModifierGroupMutation();
  const navigate = useNavigate();

  const initialValues = {
    displayName: "",
    price: undefined,
    restaurant: restaurantId,
    modifierOptions: [],
    quantityInfo: {},
    displayOrder: 1,
  };
  return (
    <div className="p-4 w-full">
      <ModifierGroupForm
        initialValues={initialValues}
        validationSchema={modifierGroupSchema}
        isLoading={isLoading}
        restaurantId={restaurantId}
        onSubmit={async (values, { resetForm }) => {
          const formattedModifierOptions = values.modifierOptions.map(
            (option: ModifierOption) => option._id
          );
          values.modifierOptions = formattedModifierOptions;
          const result = await CreateModifierGroup(values);
          if (!result.error) {
            showToast("Groupe de suppléments créé", ToastType.SUCCESS);
            resetForm();
            navigate("/modifier-groups");
          }
        }}
      />
    </div>
  );
};

export default CreateModifierGroupWrapper;
